<template>
    <v-dialog
      v-model="indicacaoDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="indicacaoDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Habilitação de Indicados - Conselho
          </v-toolbar-title>
        </v-toolbar>
        <v-card v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR">
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-layout
                  row
                  justify-space-between
                  pl-5
                  pr-5
                >
                  <v-flex
                    v-if="!conselho.avaliador"
                    sm11
                  >
                    <v-btn
                      color="secondary"
                      round
                      @click="abrirDialogoSelecaoAvaliador"
                    >
                      <v-icon left>
                        add
                      </v-icon>
                      Incluir Avaliador
                    </v-btn>
                  </v-flex>
                  <v-flex
                    v-else
                    sm11
                  >
                    <v-layout>
                      <v-text-field
                        :value="conselho.avaliador.no_nome"
                        style="max-width: 320px; margin-right: 50px;"
                        label="Nome do Avaliador"
                        append-icon="perm_identity"
                        disabled
                      />
                      <v-text-field
                        :value="conselho.avaliador.nu_cpf"
                        style="max-width: 240px;"
                        label="CPF do Avaliador"
                        append-icon="person"
                        mask="###.###.###-##"
                        disabled
                      />
                    </v-layout>
                    <v-btn
                      round
                      color="secondary"
                      @click="abrirDialogoSelecaoAvaliador"
                    >
                      <v-icon
                        small
                        left
                      >
                        edit
                      </v-icon>
                      Alterar Avaliador
                    </v-btn>
                  </v-flex>
                  <v-flex sm2>
                    <v-btn
                      max-width="20px"
                      round
                      color="gray"
                      small
                      @click="abrirDialogoHistorico"
                    >
                      <v-icon
                        left
                        small
                      >
                        history
                      </v-icon>
                      Histórico
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
  
        <card-carregando v-if="loading" />
        <v-card
          v-else
        >
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-tabs
                  v-model="tabs"
                  centered
                  icons-and-text
                  show-arrows
                >
                  <v-tab
                    v-for="(indicado, index) in indicadosConselho"
                    :key="indicado.co_indicado_conselho"
                    :href="`#tab-${index+1}`"
                    mandatory
                  >
                    {{ index+1 }}º Representante
                    <v-icon
                      center
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-tab>
                </v-tabs>
                <v-tabs-items
                  v-model="tabs"
                >
                  <v-tab-item
                    v-for="(indicado, index) in indicadosConselho"
                    :key="indicado.co_indicado_conselho"
                    :value="`tab-${index+1}`"
                  >
                    <indicacao-conselho-habilitacao-component
                      :co-conselho="conselho.co_conselho"
                      :indicado="indicado"
                      :is-loading-component="loading"
                      @fechar="indicacaoDialog = false"
                      @salvo="salvar"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card>
  
      <v-layout justify-center>
        <selecao-avaliador-dialog
          v-model="modalSelecaoAvaliador"
          :props-avaliador="selecaoAvaliador"
          :is-loading="isLoadingSelecao"
          @alterar="alterarAvaliador"
        />
      </v-layout>
  
      <v-layout justify-center>
        <historico-habilitacao-indicacao-dialog
          v-model="modalDialogoHistorico"
          :conselho="conselho.co_conselho"
					:is-loading="isLoadingHistorico"
        />
      </v-layout>
    </v-dialog>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  
  import codigosPerfil from '@/modules/conta/utils/codigosPerfil';
  
  import CardCarregando from '@/modules/shared/components/CardCarregando.vue';
  import SelecaoAvaliadorDialog from '@/modules/recurso/views/components/SelecaoAvaliadorDialog';
  import HistoricoHabilitacaoIndicacaoDialog from './HistoricoHabilitacaoIndicacaoDialog.vue';
  import IndicacaoConselhoHabilitacaoComponent from './IndicacaoConselhoHabilitacaoComponent.vue';
  
  export default {
    name: 'DialogIndicacaoConselho',
  
    components: {
      CardCarregando,
      SelecaoAvaliadorDialog,
      HistoricoHabilitacaoIndicacaoDialog,
      IndicacaoConselhoHabilitacaoComponent,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      dadosConselho: {
        type: Object,
        default: () => {},
      },
    },
  
    data() {
      return {
        codigosPerfil,
        indicacaoDialog: false,
        modalSelecaoAvaliador: false,
        modalDialogoHistorico: false,
        indicadosConselho: [],
        conselho: {},
        loading: false,
        isLoadingHistorico: false,
        isLoadingSelecao: false,
        usuarioLogado: {},
        tabs: 'tab-1',
        selecaoAvaliador: {
          co_usuario: 0,
          co_objeto: 0,
        },
  
      };
    },
  
    watch: {
      value(alternarDialogIndicacao) {
        this.indicacaoDialog = alternarDialogIndicacao;
      },
      indicacaoDialog(alternarDialog) {
				this.$emit('input', alternarDialog);
				if(!alternarDialog){
					this.dadosConselho = {}
				}
			},
			dadosConselho(valor) {
				if (Object.keys(valor).length && this.indicacaoDialog) {
					this.conselho = Object.assign({}, valor);
					this.loading = true;
	
					this.selecaoAvaliador = {
						co_usuario: valor.avaliador ? valor.avaliador.co_usuario : 0,
						co_objeto: valor.co_conselho,
					};
					this.isLoadingHistorico = true;
					this.obterHistoricoIndicacao(valor.co_conselho);

					this.obterIndicadosPorConselho(valor.co_conselho)
					.then(response => this.indicadosConselho = response)
					.finally(() => this.loading = false);
				}
			},
    },
    computed: {
      ...mapGetters({
        perfil: 'conta/perfil',
        avaliadores: 'conta/usuarios',
      }),
    },
    methods: {
      ...mapActions({
        obterIndicadosPorConselho: 'conselho/obterIndicadosPorConselho',
        obterHistoricoIndicacao: 'conselho/obterHistoricoHabilitacaoIndicacao',
        atualizarAvaliador: 'conselho/atualizarAvaliadorIndicacao'
      }),
      abrirDialogoSelecaoAvaliador() {
        this.modalSelecaoAvaliador = true;
        return true;
      },
      abrirDialogoHistorico() {
        this.modalDialogoHistorico = true;
        return true;
      },
      fecharDialogoSelecaoAvaliador() {
        this.modalSelecaoAvaliador = false;
      },
      alterarAvaliador(avaliadorSelecionado) {
        if (this.conselho.avaliador
                  && (this.conselho.avaliador.co_usuario == avaliadorSelecionado.co_usuario
                      || !avaliadorSelecionado.co_usuario
                      || avaliadorSelecionado.co_usuario == 0)) {
          this.fecharDialogoSelecaoAvaliador();
          return;
        }
        this.isLoadingSelecao = true;
        this.atualizarAvaliador(avaliadorSelecionado).finally(() => {
          this.conselho.avaliador = this.avaliadores.find(item => item.co_usuario === avaliadorSelecionado.co_usuario);
          this.isLoadingSelecao = false;
          this.isLoadingHistorico = true;
          this.obterHistoricoIndicacao(this.conselho.co_habilitacao_conselho);
          this.fecharDialogoSelecaoAvaliador();
        });
      },
      salvar(){
        this.$emit('salvo');
        this.indicacaoDialog = false;
      },
    }
  };
  </script>
  